export default "__VITE_ASSET__BnHMZOdo__"